import React from 'react';
import { func, string, node, object } from 'prop-types';
import { themr } from 'react-css-themr';

import { XMarkIcon } from '@snapask/common-components';

import styles from './BottomDialog.scss';

function BottomDialog({ clickClose, title, descr, children, theme }) {
  return (
    <div className={theme.root}>
      <span className={theme.closeBtn} onClick={clickClose}>
        <XMarkIcon width={10} height={10} />
      </span>
      <h1>{title}</h1>
      <span>{descr}</span>
      <div className={theme.buttonBlock}>{children}</div>
    </div>
  );
}

BottomDialog.propTypes = {
  children: node.isRequired,
  clickClose: func.isRequired,
  descr: string.isRequired,
  theme: object.isRequired,
  title: string.isRequired,
};

export default themr('BottomDialog', styles)(BottomDialog);



// WEBPACK FOOTER //
// ./app/components/BottomDialog/BottomDialog.jsx